import { Component, Input } from "@angular/core";

@Component({
  selector: "app-industry-tab",
  templateUrl: "./industry-tab.component.html",
  styleUrls: ["./industry-tab.component.scss"],
})
export class IndustryTabComponent {
  @Input() items: { subject: string; description: string; image: string }[] =
    [];
  selectedIndex = 0;

  selectTab(index: number) {
    this.selectedIndex = index;
  }
}
